import React from 'react'
import CatalogItemBaseList, {
  CatalogItemBaseListProps,
} from 'ui-shared/WrappedInputs/CatalogItemBaseList'

const RentSectionList: React.FC<CatalogItemBaseListProps> = (props) => (
  <CatalogItemBaseList {...props} />
)

export default RentSectionList
